import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DEFAULT_THEME_ID } from '../../themes';

type ThemeMode = 'light' | 'dark';

interface ThemeState {
  mode: ThemeMode;
  selectedThemeId: string;
}

const THEME_MODE_KEY = 'themeMode';
const THEME_ID_KEY = 'themeId';

const loadFromStorage = (): ThemeState => {
  try {
    const mode = localStorage.getItem(THEME_MODE_KEY) as ThemeMode | null;
    const selectedThemeId = localStorage.getItem(THEME_ID_KEY);
    return {
      mode: mode === 'dark' ? 'dark' : 'light',
      selectedThemeId: selectedThemeId ?? DEFAULT_THEME_ID,
    };
  } catch {
    return { mode: 'light', selectedThemeId: DEFAULT_THEME_ID };
  }
};

export { THEME_MODE_KEY, THEME_ID_KEY };

const initialState: ThemeState = loadFromStorage();

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemeMode: (state, action: PayloadAction<ThemeMode>) => {
      state.mode = action.payload;
      state.selectedThemeId = DEFAULT_THEME_ID;
    },
    toggleTheme: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
      state.selectedThemeId = DEFAULT_THEME_ID;
    },
    setSelectedTheme: (state, action: PayloadAction<string>) => {
      state.selectedThemeId = action.payload;
    },
  },
});

export const { setThemeMode, toggleTheme, setSelectedTheme } = themeSlice.actions;
export default themeSlice.reducer;
